// Alexis Buonasena
// Click.ar
import React from 'react';
import WhoisLookup from "./WhoisLookup";

function App() {
    return (
        <div className="container mt-5">
            <WhoisLookup />
        </div>
    );
}

export default App;
